import { styled } from 'styled-components';

import {
  colors,
  fontFamilyCamptonMedium,
  fontFamilyCamptonRegular,
  fontFamilyCamptonSemiBold,
} from '../../styles/sharedStyled';

export const ClaimsAccordionTitle = styled.h3`
  font-size: 25px;
  font-family: ${fontFamilyCamptonMedium};
  line-height: normal;
  margin-bottom: 24px;
  padding: 0;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 40px;
  }

  @media (min-width: 1024px) {
    font-size: 36px;
    margin-bottom: 32px;
  }
`;

export const ClaimsAccordionWrapper = styled.div`
  position: relative;
  background-color: ${colors.white};
  border-radius: 20px;
  margin-bottom: 24px;
  z-index: 5;

  @media (min-width: 768px) {
    margin-bottom: 32px;
    width: 754px;
  }

  @media (min-width: 1024px) {
    width: 880px;
    margin-bottom: 48px;
  }
`;

export const ClaimsAccordionHeader = styled.h3<{ $isOpen: boolean }>`
  font-family: ${({ $isOpen }) =>
    $isOpen ? fontFamilyCamptonSemiBold : fontFamilyCamptonMedium};
  width: 247px;
  color: ${({ $isOpen }) => ($isOpen ? colors.purple7 : colors.black)};
  font-size: 16px;
  margin: 0;
  padding: 0;
  line-height: 23px;

  @media (min-width: 768px) {
    width: 100%;
    font-size: 18px;
    line-height: 30px;
  }
`;

export const ClaimsAccordionText = styled.p`
  font-family: ${fontFamilyCamptonRegular};
  line-height: 30px;
  font-size: 16px;
  margin: 10px 0 20px;

  @media (min-width: 768px) {
    font-size: 18px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ClaimsAccordionLink = styled.a`
  text-decoration: underline;
`;

export const ClaimsAccordionListItem = styled.li`
  font-family: ${fontFamilyCamptonRegular};
  line-height: 30px;
  font-size: 16px;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;
